import { K5_THEME, MS_THEME } from '../components/AppWrapper/constants'

// Some launches send a program-level theme that has no dedicated theme
// module. Map those to an existing grade theme so consumers (done slide,
// etc.) can resolve backgrounds and fonts.
export const THEME_ALIASES = {
  [MS_THEME]: 'grade8',
  [K5_THEME]: 'grade5',
}

export const resolveThemeId = themeId =>
  (themeId && THEME_ALIASES[themeId]) || themeId

export const getGradeFromThemeParam = () => {
  const { search } = window.location || {}
  const params = search && new URLSearchParams(search)

  if (params?.get) {
    const theme = params.get('theme')
    return theme ? resolveThemeId(theme) : null
  }
  // satisfy unit test case:
  return null
}
